module.exports = "/React/dist/64c405a066ca24835c1a0b3069b4544d.gif";